<template>
  <!-- 拼团管理 -->
  <div class="spellGroup">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['促销管理', $route.meta.title]"
    >
      <template slot="controls">
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="handleAdd('')"
          >新增拼团活动</el-button
        >
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <label class="label">活动状态：</label>
        <el-select
          v-model="searchForm.status"
          placeholder="活动状态"
          style="width: 100px; margin-right: 5px"
          clearable
        >
          <el-option label="全部" value="99"></el-option>
          <el-option label="未上架" value="1"></el-option>
          <el-option label="已上架" value="2"></el-option>
        </el-select>
        <el-input
          v-model="searchForm.name"
          style="width: 150px; margin-right: 5px"
          clearable
          placeholder="输入编号/名称"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="getTableData(1)"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      @selection-change="selectionChange"
      style="width: 100%"
    >
      <el-table-column label="序号" align="center" width="50">
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="id"
        width="100"
        show-overflow-tooltip
        label="方案编号"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="name"
        width="200"
        show-overflow-tooltip
        label="拼团名称"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="goodsName"
        show-overflow-tooltip
        label="商品名称"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="price"
        show-overflow-tooltip
        label="活动单价"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="num"
        show-overflow-tooltip
        label="成团人数"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="minGoodsNum"
        show-overflow-tooltip
        label="最小商品购买数量"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="maxGoodsNum"
        show-overflow-tooltip
        label="最大商品购买数量"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="goodsNum"
        show-overflow-tooltip
        label="参与拼团商品数量"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="maxGroupNum"
        show-overflow-tooltip
        label="拼团上限"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="time"
        show-overflow-tooltip
        label="持续时间(小时)"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="isNoSatisfy"
        show-overflow-tooltip
        label="条件不满足时是否开启"
      >
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-tag type="warning" v-if="scope.row.status == 1">未上架</el-tag>
          <el-tag type="success" v-if="scope.row.status == 2">已上架</el-tag>
          <el-tag type="info" v-if="scope.row.status == 3">已结束</el-tag>
          <el-tag type="danger" v-if="scope.row.status == 0">已删除</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="160">
        <template slot-scope="scope">
          <el-button
            type="primary"
            style="padding: 2px 3px"
            plain
            @click="handleAdd(scope.row.id)"
            v-show="scope.row.status == 1"
            >编辑</el-button
          >
          <el-button
            type="success"
            style="padding: 2px 3px"
            plain
            @click="changeStatus(scope.row, 2)"
            v-show="scope.row.status == 1"
            >上架</el-button
          >
          <el-button
            type="danger"
            style="padding: 2px 3px"
            plain
            @click="changeStatus(scope.row, 1)"
            v-show="scope.row.status == 2"
            >下架</el-button
          >
          <el-button
            type="warning"
            style="padding: 2px 3px"
            plain
            @click="changeStatus(scope.row, 0)"
            v-show="scope.row.status == 1"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
  </div>
</template>

<script>
export default {
  name: "spellGroup",
  data() {
    return {
      /**表格数据 */
      // {
      //   id: "活动ID",
      //   name: "拼团名称",
      //   goodsId: "商品ID",
      //   goodsName: "商品名称",
      //   price: "商品单价",
      //   num: "成团人数",
      //   minGoodsNum: "最小商品购买数量",
      //   maxGoodsNum: "最大商品购买数量",
      //   maxGroupNum: "拼团上限",
      //   goodsNum: "参与拼团商品数量",
      //   time: "持续时间(小时)",
      //   isNoSatisfy: "条件不满足时是否开启",
      //   des: "备注",
      //   status: "状态",
      // }
      tableData: [],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      selectedList: [],
      /**搜索表单 */
      searchForm: {
        status: "99", // 方案状态
        name: "",
      },
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    updata() {
      this.getTableData();
    },
    /**获取表格 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      let data = {
        type: "GetpintuanList",
        PageIndex: this.currPage,
        PageSize: this.pageSize,
        status: this.searchForm.status,
        strWhere: this.searchForm.name,
      };
      let proc = "Proc_Admin_pintuan"; // 存储过程名
      let type = "ReturnList";
      this.$requestSys({
        url:
          "prom/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        method: "post",
      })
        .then((res) => {
          this.tableData = [];
          if (res.flag == 0) {
            this.allPage = res.recordCount;
            this.tableData = (res.data || []).map((item) => ({
              id: item.fabh,
              name: item.ptname,
              goodsId: item.article_id,
              goodsName: item.sub_title,
              price: item.group_price,
              num: item.population,
              minGoodsNum: item.clientMinNum,
              maxGoodsNum: item.clientMaxNum,
              maxGroupNum: item.maxGroupNum,
              goodsNum: item.maxGoodsNum,
              time: item.continued_time,
              isNoSatisfy: item.isSuccess == 1 ? "是" : "否",
              des: item.remarks,
              status: item.status,
            }));
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    /**selection change触发事件 */
    selectionChange(section) {
      //存放选中的表格数据
      this.selectedList = section;
    },
    /**点击新增/编辑 */
    handleAdd(id) {
      let prams = encodeURIComponent(JSON.stringify({ id: id }));
      this.$router.push({
        path: "addSpellGroup",
        query: {
          prams: prams,
        },
      });
    },
    changeStatus(row, status) {
      let msg = "确定要执行操作吗?";
      let msgType = "info";
      if (status == 2) {
        msg = "确定上架吗?";
        msgType = "success";
      } else if (status == 1) {
        msg = "确定下架吗?";
        msgType = "warning";
      } else if (status == 0) {
        msg = "确定删除吗?";
        msgType = "error";
      }
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: msgType,
      })
        .then(() => {
          let data = {
            fabh: row.id,
            status: status,
          };
          this.$request({
            url: "PinTuan/SpellGroupStatus",
            method: "post",
            data: data,
          })
            .then((res) => {
              if (res.success) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.getTableData();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.spellGroup {
  width: 100%;
  height: 100%;
}
</style>
